module.exports = __webpack_public_path__ + "img/cover-contribute.0c765872.jpg";